/**
 * Shared constants for timeline components
 * Centralizes magic numbers for easy maintenance
 */

// Dot dimensions
export const TIMELINE_DOT_DIAMETER = 8; // pixels

// Line dimensions
export const TIMELINE_LINE_WIDTH = 2; // pixels

// Positioning
export const TIMELINE_DAY_DOT_OFFSET = 37; // pixels from top of day card

// Note: Color uses theme.palette.primary.main directly via useTheme() or sx callback
